import { apiClient } from './client';
import { Contract, ContractPayload } from '../types/contract';

export async function fetchContracts(keyword?: string): Promise<Contract[]> {
  const { data } = await apiClient.get<Contract[]>('/contracts', {
    params: keyword?.trim() ? { q: keyword.trim() } : {},
  });
  return data;
}

export async function fetchPendingDeletionContracts(): Promise<Contract[]> {
  const { data } = await apiClient.get<Contract[]>('/contracts/pending-deletion');
  return data;
}

export interface ContractCalendarItem {
  kind: string;
  date: string;
  contractId: number;
  contractName?: string | null;
  documentNo?: string | null;
  contractNo?: string | null;
}

export async function fetchContractCalendar(
  from: string,
  to: string
): Promise<ContractCalendarItem[]> {
  const { data } = await apiClient.get<ContractCalendarItem[]>('/contracts/calendar', {
    params: { from, to },
  });
  return data;
}

export async function fetchContract(contractId: number): Promise<Contract> {
  const { data } = await apiClient.get<Contract>(`/contracts/${contractId}`);
  return data;
}

export async function createContract(payload: ContractPayload): Promise<Contract> {
  const { data } = await apiClient.post<Contract>('/contracts', payload);
  return data;
}

export async function updateContract(
  contractId: number,
  payload: ContractPayload
): Promise<Contract> {
  const { data } = await apiClient.patch<Contract>(`/contracts/${contractId}`, payload);
  return data;
}

export async function deleteContract(contractId: number): Promise<void> {
  await apiClient.delete(`/contracts/${contractId}`);
}

export async function restoreContract(contractId: number): Promise<Contract> {
  const { data } = await apiClient.post<Contract>(`/contracts/${contractId}/restore`);
  return data;
}

export async function updateContractCurrentStage(
  contractId: number,
  stageId: number
): Promise<Contract> {
  const { data } = await apiClient.patch<Contract>(`/contracts/${contractId}/current-stage`, {
    stageId,
  });
  return data;
}
